import { EntryItem } from '@com-delta-omnichannel/aura';
import {
  AmexCardlActivityMocks,
  CarRentalActivityMocks,
  FlightActivityMocks,
  JapanCardActivityMocks,
  OtherActivityMocks,
  StayActivityMocks,
  VacationActivityMocks
} from './activity-value.mocks';

export const ActivityMocks: EntryItem[] = [
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Flights</span>',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-flights-solid.svg',
    value: FlightActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Flights logo'
    }
  },
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Amex MQDs</span>',
      subtitle: 'Delta SkyMiles® Reserve Card'
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/amex-reserve-card.svg',
    value: AmexCardlActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Amex MQDs logo'
    },
    info: 'Delta SkyMiles® Reserve Card: $1 MQD = $10 spent'
  },
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Japan Credit Card MQDs</span>',
      subtitle: 'Delta SkyMiles® TRUST CLUB Platinum Visa Card'
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/cards/japan-trust-club-platinum-card.svg',
    value: JapanCardActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Japan Credit Card MQDs logo'
    },
    info: 'Japan Visa: $1 MQD = $5 USD spent'
  },
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Delta Rental Cards</span>',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-rental-car-solid.svg',
    value: CarRentalActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Delta Rental Cards logo'
    }
  },
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Delta Stays</span>',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-stays-solid.svg',
    value: StayActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Delta Stays logo'
    }
  },
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Delta Vacations</span>',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/delta-vacations-solid.svg',
    value: VacationActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Delta Vacations logo'
    },
    info: 'Earn $1 MQD per $1 spent on your vacation package. Terms apply. Miles and MQD earn is only available on packages originating in the U.S.'
  },
  {
    content: {
      title:
        '<span class="skymiles-landing-page-earns-summary__title">Other</span>',
      subtitle: ''
    },
    state: '',
    icon: '/content/dam/delta-applications/ui-kit/assets/svg/skymiles/tracker/mqd-summary/other-mqd-solid.svg',
    value: OtherActivityMocks,
    border: 'none',
    ariaLabel: {
      icon: 'Other logo'
    },
    info: "Other MQD's can be earned through several ways including upgrades, checked baggage and promotions."
  }
];
